import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_512: DocMigration = {
  maxSchemaVersion: "0.0.512",
  description: "Add default LEVEL datums to datums table",
  apply(json: any): any {
    if (!json.datums) {
      json.datums = {};
    }

    if (!json.entityGroups) {
      json.entityGroups = {};
    }

    json.datums["LEVEL_FLOOR_ELEVATION"] = {
      entityType: "DATUM",
      id: "LEVEL_FLOOR_ELEVATION",
      sortIndex: 0,
      name: "Level floor elevation",
      datumType: "LEVEL",
      direction: "VERTICAL",
      offsetType: "RELATIVE",
      offset: 0,
      anchor: "LEVEL_FLOOR_ELEVATION",
      justification: "BOTTOM_UP",
      offsetNormalized: false,
    };

    json.entityGroups["datum.LEVEL_FLOOR_ELEVATION"] = "builtInDatumsGroup";

    json.datums["LEVEL_TOP_OF_WALL"] = {
      entityType: "DATUM",
      id: "LEVEL_TOP_OF_WALL",
      sortIndex: 1,
      name: "Level top of wall",
      datumType: "LEVEL",
      direction: "VERTICAL",
      offsetType: "RELATIVE",
      offset: 0,
      anchor: "LEVEL_TOP_OF_WALL",
      justification: "BOTTOM_UP",
      offsetNormalized: false,
    };

    json.entityGroups["datum.LEVEL_TOP_OF_WALL"] = "builtInDatumsGroup";

    return json;
  },
};

export default migration_0_0_512;
